import { useState, useEffect } from "react";
import ContactHero from "../components/ContactHero";
import ContactDetails from "../components/ContactDetails";
import SeoHead from "../components/seo/SeoHead";
import Waves from "../blocks/Backgrounds/Waves/Waves";
import ContactInfo from "../components/ContactInfo";
import NewsletterSignup from "../components/newsletter/NewsletterSignup";
import { useTranslation } from "../i18n";
import "./Contact.css";

function Contact() {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);
        
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile(); // Verifica al cargar

        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <div>
            <SeoHead
                title="Contacto | TheQAHub"
                description="Contacta con TheQAHub para colaboraciones, dudas o propuestas relacionadas con QA, testing y automatizacion."
                canonicalPath="/contacto"
            />
            <ContactHero />
            <>
                {isMobile ? (
                    <div className="waves-section">
                        <Waves 
                            lineColor="#97b79e" 
                            backgroundColor="transparent" 
                            waveSpeedX={0.02}
                            waveSpeedY={0.005}
                            waveAmpX={25}
                            waveAmpY={10}
                            xGap={12}
                            yGap={20}
                            className="custom-waves"
                        />
                        <p className="waves-text">{t("contact.wavesMobile")}</p>
                    </div>
                ) : (
                    <div className="waves-section">
                        <Waves 
                            lineColor="#97b79e" 
                            backgroundColor="transparent" 
                            waveSpeedX={0.02}
                            waveSpeedY={0.005}
                            waveAmpX={25}
                            waveAmpY={10}
                            xGap={12}
                            yGap={20}
                            className="custom-waves"
                        />
                        <p className="waves-text">{t("contact.waves")}</p>
                    </div>
                )}
            </>
            <ContactDetails />

            {/* Barra separadora */}
            <hr className="section-divider" />

            <NewsletterSignup />

            {/* Barra separadora */}
            <hr className="section-divider" />

            {/* 🔹 Sección del Mapa */}
            <div className="map-section">
                <iframe
                    title="Ubicación Ponferrada"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47025.02353786406!2d-6.651051005161342!3d42.55393451874789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd30ba8c4ef7b633%3A0xdc636ce1ab239060!2sPonferrada%2C%20Le%C3%B3n!5e0!3m2!1ses!2ses!4v1739058630674!5m2!1ses!2ses"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>

            {/* 🔹 Nueva Sección Informativa debajo del mapa */}
            <div className="contact-summary">
                <h3>{t("contact.summaryTitle")}</h3>
                <p>
                    {t("contact.summaryText")}
                </p>
                <div className="summary-buttons">
                    <a href="/contacto" className="summary-button primary">{t("contact.contactButton")}</a>
                    <a href="/sobre-mi" className="summary-button secondary">{t("contact.aboutButton")}</a>
                </div>
            </div>

            <ContactInfo />
        </div>
    );
}

export default Contact;
